import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

const DrawerHeader = ({ onClose }: any) => (
  <Box
    sx={{ display: "flex", justifyContent: "space-between", padding: "16px" }}
  >
    <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
  </Box>
);

export default DrawerHeader;
